import React, { useEffect, useState } from 'react';
import { useAtom } from 'jotai/index';
import moment from 'moment';
import styles from './css/index.module.scss';
import { selectedNicknameAtom } from '../../atoms/nicknamesAtoms';
import PageTitle from '../../components/PageTitle';
import EmptyHeight from '../../components/EmptyHeight';
import { statusesAtom } from '../../atoms/staticAtoms';
import MyButton from '../../components/MyButton';
import sendRequest from '../../helpers/sendRequest';
import Api from '../../api';
import MyInput from '../../components/MyInput';

function SingleNickname() {
  const [selectedNickname] = useAtom(selectedNicknameAtom);
  const [statuses] = useAtom(statusesAtom);
  const [newStatus, setNewStatus] = useState('');
  const [newComment, setNewComment] = useState('');

  const [sortedStatuses, setSortedStatuses] = useState([]);

  const onSaveClick = async () => {
    if (!newStatus || newStatus === '-') return;
    const data = await sendRequest({
      request: Api.changeNicknameStatus,
      payload: { statusCode: newStatus, nicknameId: selectedNickname._id, comment: newComment },
    });

    if (data?.status !== 'ok') return;

    setNewStatus('');
    setNewComment('');
    setSortedStatuses((prev) => [data.newNicknameHistory, ...prev]);
  };

  useEffect(() => {
    if (selectedNickname?.statusHistory?.length) {
      setSortedStatuses(selectedNickname.statusHistory.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1)));
    }
  }, [selectedNickname?.statusHistory]);

  if (!selectedNickname?._id) {
    return <p>No nickname is selected</p>;
  }

  return (
    <div>
      <PageTitle text="Single nickname" />
      <EmptyHeight height={30} />
      <div className={styles.infoRow}>
        <span>nickname:</span>
        {selectedNickname.nickname}
      </div>
      <div className={styles.infoRow}>
        <span>adder admin:</span>
        {selectedNickname.adderAdmin.name}
      </div>
      <div className={styles.infoRow}>
        <span>language:</span>
        {selectedNickname.language}
      </div>
      <div className={styles.infoRow}>
        <span>creation time:</span>
        {moment(selectedNickname.createdAt).format('DD-MM-YY HH:mm')}
      </div>

      <div className={styles.newStatusRow}>
        <span>New Status:</span>
        <select value={newStatus} onChange={(ev) => setNewStatus(ev.target.value)}>
          <option value="-">-</option>
          {Object.keys(statuses).map((statusCode) => (
            <option key={statusCode} value={statusCode}>
              {statuses[statusCode]}
              {' '}
              (
              {statusCode}
              )
            </option>
          ))}
        </select>

        <div className={styles.newStatusInput}>
          <MyInput
            value={newComment}
            onChange={(ev) => setNewComment(ev.target.value)}
            labelTextTop="Comment (optional)"
            withLeftIcon={false}
          />
        </div>
        <MyButton disabled={!newStatus || newStatus === '-'} text="Save" onClick={onSaveClick} />
      </div>

      <div className={styles.statusesBlock}>
        {sortedStatuses.map((nicknameStatus) => (
          <div className={styles.statusesRow} key={nicknameStatus._id}>
            <span className={styles.statusesAdmin}>{nicknameStatus.admin}</span>
            <span className={styles.statusesDate}>{moment(nicknameStatus.updatedAt).format('DD-MM-YY HH:mm')}</span>
            <span className={styles.statusesCode}>{nicknameStatus.status}</span>
            <span className={styles.statusesName}>{statuses[nicknameStatus.status]}</span>
            <span className={styles.statusesComment}>{nicknameStatus.comment}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SingleNickname;
